import { z } from 'zod';
// ============================================================
// 付喪神ストア型定義（Phase 4-4）
//
// 自動生成された付喪神プロファイルのストレージ・ワークフロー用の
// 型定義とステータス管理。Worker API と Studio UI の両方で使用する。
// ============================================================
// ----------------------------------------------------------
// ステータス管理
// ----------------------------------------------------------
export const TsukumogamiStatusEnum = z.enum([
    'generated', // 生成直後（バリデーション未通過を含む）
    'pending_review', // バリデーション通過、人間レビュー待ち
    'approved', // 人間が承認済み
    'rejected', // 人間がリジェクト
]);
/** ステータスの日本語ラベル */
export const TSUKUMOGAMI_STATUS_LABELS = {
    generated: '生成済み',
    pending_review: 'レビュー待ち',
    approved: '承認済み',
    rejected: 'リジェクト',
};
/** ステータスの表示色（Tailwind CSS クラス用） */
export const TSUKUMOGAMI_STATUS_COLORS = {
    generated: 'text-gray-400',
    pending_review: 'text-amber-400',
    approved: 'text-green-400',
    rejected: 'text-rose-400',
};
/** Supabase行 → TypeScript行への変換ヘルパー */
export function mapSupabaseRow(row) {
    return {
        id: row.id,
        profileJson: row.profile_json,
        originalObject: row.original_object,
        arikata: row.arikata,
        gradeLevel: row.grade_level,
        gradeSub: row.grade_sub,
        tone: row.tone,
        status: row.status,
        validationJson: row.validation_json || null,
        generationMeta: row.generation_meta || null,
        reviewerNotes: row.reviewer_notes || null,
        createdAt: row.created_at,
        updatedAt: row.updated_at,
        approvedAt: row.approved_at || null,
    };
}
//# sourceMappingURL=tsukumogamiStore.js.map